var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentGirlVectorGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 484,
    viewBox: "0 0 395 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.296 356.33C31.1066 336.554 50.1867 342.13 63.663 357.76C77.1393 373.39 87.3941 397.025 100.316 414.214C117.747 437.417 140.823 447.873 161.251 435.76C181.679 423.648 197.986 386.441 197.041 346.639C196.332 316.831 186.908 290.593 178.755 264.878C171.758 242.802 165.38 219.289 163.841 193.831C162.302 168.373 166.407 140.464 177.232 124.606C190.671 104.936 210.452 108.802 225.989 122.163C241.526 135.523 254.713 156.85 269.928 171.437C296.995 197.379 331.164 199.588 357.53 171.278C383.896 142.968 400.227 82.648 393.475 27.4804C392.518 19.6425 390.885 11.3583 387.219 7.05352C384.287 3.64148 380.63 3.475 377.172 3.41447C251.465 1.11456 125.74 1.36674 0 4.17102C15.6429 109.574 15.8424 247.152 19.3042 356.307",
    fill: "url(#paint0_linear_3037_1505)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7917 483.595C39.8544 484.353 66.614 471.61 87.0403 441.499C107.467 411.388 120.622 362.575 117.696 314.399C115.483 278.011 104.813 245.565 98.1867 211.072C91.56 176.58 89.7831 134.013 103.077 107.018C114.036 84.7912 132.453 80.0381 148.181 87.399C163.908 94.76 177.626 112.203 191.006 129.245C204.386 146.287 218.185 163.571 233.961 170.53C256.376 180.385 281.351 166.838 297.376 136.06C313.401 105.282 319.889 58.4025 313.853 17.0415L29.792 0.121109C22.4113 -0.318578 14.0607 -0.0683858 8.97856 9.90797C4.60557 18.4819 4.15319 31.4299 3.94126 43.2635C1.41039 184.358 -0.806674 345.078 13.7754 483.618",
    fill: "url(#paint1_linear_3037_1505)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 323.658C264.031 323.658 275 303.671 275 279.016C275 254.36 264.031 234.373 250.5 234.373C236.969 234.373 226 254.36 226 279.016C226 303.671 236.969 323.658 250.5 323.658Z",
    fill: "url(#paint2_linear_3037_1505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3037_1505",
    x1: 197.493,
    y1: 440.844,
    x2: 197.493,
    y2: 1.90138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3037_1505",
    x1: 159.103,
    y1: 483.633,
    x2: 159.103,
    y2: 0.00737954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#138CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#1DABE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3037_1505",
    x1: 250.5,
    y1: 234.373,
    x2: 250.5,
    y2: 323.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentGirlVectorGraphics);
export default __webpack_public_path__ + "static/media/studentGirlVectorGraphics.96fae225078e8c5fbf0bff46a0562c7d.svg";
export { ForwardRef as ReactComponent };